// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"e2d3ae45","128":"aa982cae","281":"7168d05f","520":"b80f2e9d","685":"ce29df93","778":"cb30b056","940":"82fc2ad0"}[chunkId] + ".chunk.css";
};